(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7190,289],{

/***/ 45455:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseKeys = __webpack_require__(86411),
    getTag = __webpack_require__(70940),
    isArguments = __webpack_require__(79631),
    isArray = __webpack_require__(86152),
    isArrayLike = __webpack_require__(67878),
    isBuffer = __webpack_require__(73226),
    isPrototype = __webpack_require__(16001),
    isTypedArray = __webpack_require__(77598);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),

/***/ 18149:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(88746);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),

/***/ 63297:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/job-offers",
      function () {
        return __webpack_require__(65812);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 95805:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(70237)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadable = _interop_require_default(__webpack_require__(42060));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if ( true && loadableOptions.suspense) {
        throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
    }
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 46941:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 42060:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(60616)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(90416)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadableContext = __webpack_require__(46941);
var useSyncExternalStore = ( false ? 0 : __webpack_require__(43100)).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 88888:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ shared_CustomSelect; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(38914);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/match-sorter/dist/match-sorter.esm.js
var match_sorter_esm = __webpack_require__(71741);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-select/dist/index-4bd03571.esm.js + 1 modules
var index_4bd03571_esm = __webpack_require__(64990);
// EXTERNAL MODULE: ../../node_modules/react-select/dist/react-select.esm.js
var react_select_esm = __webpack_require__(31776);
// EXTERNAL MODULE: ../../node_modules/react-select/dist/Select-dbb12e54.esm.js
var Select_dbb12e54_esm = __webpack_require__(47931);
;// CONCATENATED MODULE: ./components/shared/CurstomSelect.constants.ts
// Constants.
// -----------------------------------------------------------------------------
var DEFAULT_CUSTOM_SELECT_MATCH_ORDER = true;

;// CONCATENATED MODULE: ./components/shared/CustomSelect.tsx
/* eslint-disable @typescript-eslint/no-explicit-any */ 









var Menu = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_4bd03571_esm.c.Menu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: props.children
    }));
};
var MultiValueSeparator = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_4bd03571_esm.c.MultiValue, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                children: props.children
            })),
            props.multiValueSeparator ? props.selectProps.value.length - 1 > props.index && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "multi-value-separator",
                children: props.multiValueSeparator
            }) : ""
        ]
    });
};
var ClearIndicator = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_4bd03571_esm.c.ClearIndicator, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
            icon: pro_light_svg_icons/* faTimes */.NBC
        })
    }));
};
var CustomSelect = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var options = param.options, placeholder = param.placeholder, _isMulti = param.isMulti, isMulti = _isMulti === void 0 ? false : _isMulti, _isSmall = param.isSmall, isSmall = _isSmall === void 0 ? false : _isSmall, id = param.id, styles = param.styles, defaultValue = param.defaultValue, _isTransparent = param.isTransparent, isTransparent = _isTransparent === void 0 ? false : _isTransparent, onChange = param.onChange, value = param.value, _matchOrder = param.matchOrder, matchOrder = _matchOrder === void 0 ? DEFAULT_CUSTOM_SELECT_MATCH_ORDER : _matchOrder, max = param.max, hideDropdownUntilSearch = param.hideDropdownUntilSearch, formatOptionLabel = param.formatOptionLabel, _variant = param.variant, variant = _variant === void 0 ? "normal" : _variant, _closeMenuOnSelect = param.closeMenuOnSelect, closeMenuOnSelect = _closeMenuOnSelect === void 0 ? true : _closeMenuOnSelect, _menuPosition = param.menuPosition, menuPosition = _menuPosition === void 0 ? "absolute" : _menuPosition, _matchFrom = param.matchFrom, matchFrom = _matchFrom === void 0 ? "any" : _matchFrom, multiValueSeparator = param.multiValueSeparator;
    var t = (0,useI18n/* useI18n */.Q)("common").t;
    var _$ref = (0,react.useState)(options), currentOptions = _$ref[0], setCurrentOptions = _$ref[1];
    var _$ref1 = (0,react.useState)(false), menuIsOpen = _$ref1[0], setMenuIsOpen = _$ref1[1];
    var handleOnInputChange = function(newValue) {
        if (hideDropdownUntilSearch) {
            setMenuIsOpen(newValue.length > 0);
        }
        if (matchOrder) {
            setCurrentOptions((0,match_sorter_esm/* matchSorter */.Lu)(options, newValue, {
                keys: [
                    "label"
                ]
            }));
        }
    };
    var MultiValueWithSeparator = (0,react.useMemo)(// eslint-disable-next-line react/display-name
    function() {
        return function(props) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiValueSeparator, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                multiValueSeparator: multiValueSeparator
            }));
        };
    }, [
        multiValueSeparator
    ]);
    (0,react.useEffect)(function() {
        setCurrentOptions(options);
    }, [
        options
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "aria-label": "id",
        options: currentOptions,
        classNamePrefix: "mf-select",
        className: "mf-select ".concat(hideDropdownUntilSearch ? "mf-select-autocomplete" : "", " ").concat(isSmall ? "cs-sm" : "", " ").concat(isTransparent ? "cs-transparent" : "", "\n        ").concat(variant === "error" ? "cs-error" : ""),
        placeholder: placeholder,
        isMulti: isMulti,
        inputId: id,
        styles: styles,
        defaultValue: defaultValue,
        menuPortalTarget:  true ? document.querySelector("body") : 0,
        formatOptionLabel: formatOptionLabel ? function(val) {
            return formatOptionLabel(val.label);
        } : undefined,
        onChange: function(newValue, actionMeta) {
            // Prevent onChange from firing when removing items with backspace
            if (actionMeta.action === "pop-value") return;
            onChange === null || onChange === void 0 ? void 0 : onChange(newValue, actionMeta);
        },
        noOptionsMessage: function() {
            return t("customSelect.noOptions");
        }
    }, !matchOrder && {
        filterOption: (0,Select_dbb12e54_esm.c)({
            ignoreAccents: true,
            ignoreCase: true,
            matchFrom: matchFrom,
            trim: true
        })
    }), {
        value: value,
        max: max,
        ref: ref,
        menuPosition: menuPosition,
        onInputChange: handleOnInputChange,
        closeMenuOnSelect: closeMenuOnSelect,
        menuIsOpen: hideDropdownUntilSearch ? menuIsOpen : undefined,
        components: hideDropdownUntilSearch ? {
            Menu: Menu,
            ClearIndicator: ClearIndicator,
            MultiValue: MultiValueWithSeparator,
            DropdownIndicator: function() {
                return null;
            },
            IndicatorSeparator: function() {
                return null;
            }
        } : {
            Menu: Menu,
            ClearIndicator: ClearIndicator,
            MultiValue: MultiValueWithSeparator
        }
    }));
});
CustomSelect.displayName = "CustomSelect";
/* harmony default export */ var shared_CustomSelect = (CustomSelect);


/***/ }),

/***/ 73412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45847);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75339);
/* harmony import */ var _HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21646);






var HeadMetadata = function(param) {
    var title = param.title, url = param.url, _desc = param.desc, desc = _desc === void 0 ? "" : _desc, imgUrl = param.imgUrl, path = param.path, _indexable = param.indexable, indexable = _indexable === void 0 ? false : _indexable, _extraMeta = param.extraMeta, extraMeta = _extraMeta === void 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}) : _extraMeta;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: imgUrl || "https://www.getmanfred.com/og-image.jpg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: desc || ""
                    }),
                    imgUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: imgUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: "Get Manfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:locale",
                        content: locale
                    }),
                    url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:url",
                                content: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                rel: "canonical",
                                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            })
                        ]
                    }),
                    indexable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "index,follow"
                    }),
                    extraMeta
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_3___default()), {
                id: "globalLDMetadata",
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '{\n          "@context": "https://schema.org",\n          "@type": "Organization",\n          "name": "Manfred",\n          "url": "https://www.getmanfred.com/",\n          "logo": "https://www.getmanfred.com/favicon.ico",\n          "description": "Plataforma de empleo para profesionales del sector tecnol\xf3gico.",\n          "sameAs": [\n            "https://twitter.com/getmanfred",\n            "https://www.linkedin.com/company/getmanfred/",\n            "https://github.com/getmanfred>"\n          ],\n          "contactPoint": [\n            {\n              "@type": "ContactPoint",\n              "email": "support@getmanfred.com",\n              "contactType": "customer service",\n              "availableLanguage": ["Spanish", "English"]\n            }\n          ],\n          "founder": {\n            "@type": "Person",\n            "name": "David Bonilla",\n            "url": "https://twitter.com/david_bonilla>"\n          },\n          "foundingDate": "2019",\n          "areaServed": "Worldwide",\n          "address": {\n            "@type": "PostalAddress",\n            "addressCountry": "ES",\n            "addressRegion": "Madrid",\n            "addressLocality": "Madrid"\n          },\n          "offers": {\n            "@type": "Service",\n            "name": "Plataforma de empleo para el sector tech",\n            "description": "Conectamos profesionales tecnol\xf3gicos con empresas mediante un enfoque centrado en la privacidad y la transparencia."\n          }\n        }'
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                url: url,
                path: path
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadata);


/***/ }),

/***/ 21646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21428);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75339);




var HeadMetadataLangAlternate = function(param) {
    var url = param.url, path = param.path;
    var getPath = function getPath(path, locale) {
        if (!path) {
            return "";
        }
        return "/".concat((0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(path, locale));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: url && Object.keys(url.langs).map(function(key) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "alternate",
                hrefLang: key,
                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_2__/* .config.appUrl */ .v.appUrl, "/").concat(key).concat(url.langs[key]).concat(getPath(path, key))
            }, key);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadataLangAlternate);


/***/ }),

/***/ 87603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ shared_Switcher; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/shared/Switcher.styled.ts
/* eslint-disable @typescript-eslint/no-explicit-any */ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      input {\n        background-color: ",
        ";\n        border-color: ",
        ";\n\n        &::after {\n          background: ",
        ";\n        }\n\n        &:checked {\n          background-color: ",
        ";\n          border-color: ",
        ";\n\n          &::after {\n            background: ",
        ";\n          }\n        }\n\n        &[disabled] {\n          background-color: ",
        ";\n          border-color: ",
        ";\n\n          &::after {\n            background-color: ",
        ";\n          }\n\n          + label {\n            color: ",
        ";\n          }\n\n          &:checked {\n            background-color: ",
        ";\n            border-color: ",
        ";\n\n            &::after {\n              background-color: ",
        ";\n            }\n          }\n        }\n\n        &:focus {\n          background-color: ",
        ";\n\n          &:checked {\n            background-color: ",
        ";\n\n            &:hover::after {\n              background-color: ",
        ";\n            }\n          }\n        }\n      }\n      label {\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  align-items: center;\n\n  input {\n    appearance: none;\n    height: ",
        ";\n    width: 3.5rem;\n    outline: none;\n    display: inline-block;\n    vertical-align: top;\n    position: relative;\n    margin: 0;\n    cursor: pointer;\n    border: 2px solid ",
        ";\n    background: ",
        ";\n    border-radius: ",
        ";\n    transition: 0.3s;\n    flex: 1 0 auto;\n\n    &::after {\n      content: '';\n      display: block;\n      position: absolute;\n      left: 3px;\n      top: 4px;\n      border-radius: 50%;\n      width: 1.25rem;\n      height: 1.25rem;\n      background: ",
        ";\n      transform: translateX(0);\n      transition: 0.3s;\n    }\n    &:checked {\n      background: ",
        ";\n      border-color: ",
        ";\n\n      &::after {\n        background: ",
        ";\n        transform: translateX(24px);\n      }\n\n      &:hover {\n        background: ",
        ";\n        border-color: ",
        ";\n\n        &::after {\n          background: ",
        ";\n        }\n      }\n    }\n\n    &:hover {\n      border-color: ",
        ";\n      &::after {\n        background: ",
        ";\n      }\n    }\n\n    &:focus {\n      outline: 0;\n      box-shadow: 0 0 0 4px ",
        ";\n      background-color: ",
        ";\n\n      &:checked {\n        background: ",
        ";\n        border-color: ",
        ";\n      }\n    }\n\n    &[disabled] {\n      pointer-events: none;\n      background-color: ",
        ";\n      border-color: ",
        ";\n\n      &::after {\n        background-color: ",
        ";\n      }\n\n      + label {\n        color: ",
        ";\n      }\n\n      &:checked {\n        border-color: ",
        ";\n      }\n    }\n  }\n\n  ",
        "\n\n  label {\n    margin-bottom: 0;\n    margin-left: ",
        ";\n    font-size: ",
        ";\n    font-weight: ",
        ";\n    flex: 1 1 auto;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var variants = {
    inverse: {
        background: (0,theme/* color */.$_)("black"),
        borderColor: (0,theme/* color */.$_)("midnight_800"),
        handleColor: (0,theme/* color */.$_)("midnight_800"),
        disabledBackground: (0,theme/* color */.$_)("midnight_900"),
        disabledBorderColor: (0,theme/* color */.$_)("midnight_850"),
        disabledHandleColor: (0,theme/* color */.$_)("midnight_850"),
        checkedBackground: (0,theme/* color */.$_)("midnight_200"),
        checkedBorderColor: (0,theme/* color */.$_)("midnight_800"),
        checkedHandleColor: (0,theme/* color */.$_)("midnight_800"),
        checkedHoverHandleColor: (0,theme/* color */.$_)("midnight_700"),
        disabledCheckedBackground: (0,theme/* color */.$_)("midnight_900"),
        disabledCheckedBorderColor: (0,theme/* color */.$_)("midnight_850"),
        disabledCheckedHandleColor: (0,theme/* color */.$_)("midnight_850"),
        labelColor: (0,theme/* color */.$_)("text_default_inverse"),
        disabledLabelColor: (0,theme/* color */.$_)("text_disabled_inverse"),
        focusBackground: (0,theme/* color */.$_)("midnight_850"),
        checkedFocusBackground: (0,theme/* color */.$_)("midnight_200")
    }
};
var StyledSwitcher = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-6de387d1-0"
})(_templateObject1(), (0,theme/* spacing */.W0)("xl"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* color */.$_)("midnight_150"), (0,theme/* radius */.q0)("full"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* color */.$_)("midnight_600"), (0,theme/* color */.$_)("midnight_600"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* color */.$_)("midnight_400"), (0,theme/* color */.$_)("midnight_400"), (0,theme/* color */.$_)("midnight_150"), (0,theme/* color */.$_)("midnight_150"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* color */.$_)("midnight_100"), (0,theme/* color */.$_)("midnight_150"), (0,theme/* color */.$_)("midnight_150"), (0,theme/* color */.$_)("text_disabled"), (0,theme/* color */.$_)("midnight_100"), function(param) {
    var variant = param.variant;
    return variant && variants[variant] && (0,styled_components_browser_esm/* css */.iv)(_templateObject(), variants[variant].background, variants[variant].borderColor, variants[variant].handleColor, variants[variant].checkedBackground, variants[variant].checkedBorderColor, variants[variant].checkedHandleColor, variants[variant].disabledBackground, variants[variant].disabledBorderColor, variants[variant].disabledHandleColor, variants[variant].disabledLabelColor, variants[variant].disabledCheckedBackground, variants[variant].disabledCheckedBorderColor, variants[variant].disabledCheckedHandleColor, variants[variant].focusBackground, variants[variant].checkedFocusBackground, variants[variant].checkedHoverHandleColor, variants[variant].labelColor);
}, (0,theme/* spacing */.W0)("xs"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("medium"));

;// CONCATENATED MODULE: ./components/shared/Switcher.tsx


var Switcher = function(param) {
    var label = param.label, id = param.id, checked = param.checked, onChange = param.onChange, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, className = param.className, defaultChecked = param.defaultChecked, variant = param.variant;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSwitcher, {
        className: className,
        variant: variant,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "checkbox",
                id: id,
                name: id,
                defaultChecked: defaultChecked,
                checked: checked,
                onChange: onChange,
                disabled: disabled
            }),
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: id,
                children: label
            })
        ]
    });
};
/* harmony default export */ var shared_Switcher = (Switcher);


/***/ }),

/***/ 99655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cd": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.Cd; },
/* harmony export */   "XJ": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.XJ; },
/* harmony export */   "aC": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.aC; },
/* harmony export */   "by": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.by; },
/* harmony export */   "k8": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.k8; },
/* harmony export */   "nL": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.nL; }
/* harmony export */ });
/* harmony import */ var _Typography_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90637);



/***/ }),

/***/ 90637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cd": function() { return /* binding */ Heading6; },
/* harmony export */   "XJ": function() { return /* binding */ Heading2; },
/* harmony export */   "aC": function() { return /* binding */ Heading3; },
/* harmony export */   "by": function() { return /* binding */ Heading5; },
/* harmony export */   "k8": function() { return /* binding */ Heading4; },
/* harmony export */   "nL": function() { return /* binding */ Heading1; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      position: relative;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: calc(",
        " * -1);\n        left: 50%;\n        transform: translateX(-50%);\n        width: ",
        ";\n        height: ",
        ";\n        background-color: ",
        ";\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-top: ",
        ";\n      user-select: none;\n\n      &::before {\n        left: 0;\n        transform: translateX(0);\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        &::before {\n          width: ",
        ";\n          height: ",
        ";\n        }\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.17;\n  margin: 0;\n\n  ",
        "\n\n  ",
        "\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n\n    ",
        "\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      position: relative;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: calc(",
        " * -1);\n        left: 50%;\n        transform: translateX(-50%);\n        width: ",
        ";\n        height: ",
        ";\n        background-color: ",
        ";\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-top: ",
        ";\n      user-select: none;\n\n      &::before {\n        left: 0;\n        transform: translateX(0);\n      }\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        &::before {\n          height: ",
        ";\n        }\n      "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.17;\n  margin: 0;\n\n  ",
        "\n  ",
        "\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n\n    ",
        "\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      position: relative;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: calc(",
        " * -1);\n        left: 50%;\n        transform: translateX(-50%);\n        width: ",
        ";\n        height: ",
        ";\n        background-color: ",
        ";\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-top: ",
        ";\n      user-select: none;\n\n      &::before {\n        left: 0;\n        transform: translateX(0);\n      }\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.12;\n  margin: 0;\n\n  ",
        "\n\n  ",
        "\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.14;\n  margin: 0;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.14;\n  margin: 0;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.14;\n  margin: 0;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}


var Heading1 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
    componentId: "sc-f61a956f-0"
})(_templateObject3(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl3"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl3"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("cyan_700"));
}, function(param) {
    var alignLeft = param.alignLeft;
    return alignLeft && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl4"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl5"));
var Heading2 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    componentId: "sc-f61a956f-1"
})(_templateObject7(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl2"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject4(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl3"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("indigo_500"));
}, function(param) {
    var alignLeft = param.alignLeft;
    return alignLeft && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject5(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl3"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject6(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl4"));
var Heading3 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
    componentId: "sc-f61a956f-2"
})(_templateObject10(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject8(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl3"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("mint_900"));
}, function(param) {
    var alignLeft = param.alignLeft;
    return alignLeft && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject9(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl2"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl3"));
var Heading4 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h4.withConfig */ .ZP.h4.withConfig({
    componentId: "sc-f61a956f-3"
})(_templateObject11(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("bold"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl2"));
var Heading5 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h5.withConfig */ .ZP.h5.withConfig({
    componentId: "sc-f61a956f-4"
})(_templateObject12(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("bold"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl"));
var Heading6 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h6.withConfig */ .ZP.h6.withConfig({
    componentId: "sc-f61a956f-5"
})(_templateObject13(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("bold"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("lg"));


/***/ }),

/***/ 28619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hz": function() { return /* binding */ StyledContent; },
/* harmony export */   "SO": function() { return /* binding */ StyledTriggerIcon; },
/* harmony export */   "WQ": function() { return /* binding */ StyledSummary; },
/* harmony export */   "X0": function() { return /* binding */ StyledTitle; },
/* harmony export */   "iO": function() { return /* binding */ StyledDetails; },
/* harmony export */   "sB": function() { return /* binding */ StyledAccordion; },
/* harmony export */   "tr": function() { return /* binding */ StyledTrigger; },
/* harmony export */   "wW": function() { return /* binding */ StyledAccordionItem; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-bottom: 1px solid ",
        ";\n  margin: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-top: 1px solid ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.142;\n  font-weight: ",
        ";\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  -webkit-appearance: none;\n  color: inherit;\n  cursor: pointer;\n  width: 100%;\n  padding: ",
        " 0;\n  display: flex;\n  align-items: center;\n  border: none;\n  background-color: transparent;\n  outline: none;\n  text-align: left;\n\n  &:focus-visible {\n    ",
        ":before {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: auto;\n  padding-left: ",
        ";\n\n  svg {\n    width: ",
        " !important;\n    height: ",
        ";\n    transition: transform 0.3s ease-in-out;\n\n    .is-active & {\n      transform: rotate(180deg);\n      transform-origin: center center;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow: hidden;\n  margin: 0;\n  transition: max-height 0.3s ease-in-out;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-bottom: ",
        ";\n  font-size: ",
        ";\n\n  p {\n    margin: 0;\n    &:not(:first-child) {\n      margin-top: ",
        ";\n    }\n  }\n\n  ul,\n  ol {\n    margin-left: 1rem;\n  }\n\n  li {\n    list-style-type: disc;\n    margin: 0;\n  }\n\n  ol li {\n    list-style-type: decimal;\n  }\n\n  img {\n    display: block;\n    margin-top: ",
        ";\n    margin-left: auto;\n    margin-right: auto;\n\n    &:not(:last-child) {\n      margin-bottom: ",
        ";\n    }\n  }\n\n  figure {\n    margin: 0;\n  }\n\n  figcaption {\n    font-weight: ",
        ";\n    color: ",
        ";\n    margin-top: ",
        ";\n  }\n\n  blockquote {\n    margin: 0;\n    font-style: italic;\n  }\n\n  .slick-track {\n    display: flex;\n    justify-content: center;\n  }\n\n  .slick-slide {\n    margin-left: ",
        ";\n    margin-right: ",
        ";\n\n    &:first-child {\n      margin-left: 0;\n    }\n  }\n\n  .slick-dots {\n    justify-content: flex-start;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var StyledAccordion = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].dl.withConfig */ .ZP.dl.withConfig({
    componentId: "sc-72941c48-0"
})(_templateObject(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_200"));
var StyledAccordionItem = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-72941c48-1"
})(_templateObject1());
var StyledSummary = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].dt.withConfig */ .ZP.dt.withConfig({
    componentId: "sc-72941c48-2"
})(_templateObject2(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_200"));
var StyledTitle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-72941c48-3"
})(_templateObject3(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("sans"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("sm"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"));
var StyledTrigger = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-72941c48-4"
})(_templateObject4(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"), StyledTitle, (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("active"));
var StyledTriggerIcon = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-72941c48-5"
})(_templateObject5(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"));
var StyledDetails = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].dd.withConfig */ .ZP.dd.withConfig({
    componentId: "sc-72941c48-6"
})(_templateObject6());
var StyledContent = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-72941c48-7"
})(_templateObject7(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("sm"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("extraBold"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_subtle"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"));


/***/ }),

/***/ 84110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* reexport safe */ _useFeatureFlag__WEBPACK_IMPORTED_MODULE_0__.y; }
/* harmony export */ });
/* harmony import */ var _useFeatureFlag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92552);



/***/ }),

/***/ 92552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useFeatureFlag; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22970);
/* harmony import */ var context_logged_user_loggeduser_context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23357);
/* harmony import */ var flagsmith_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98861);
/* harmony import */ var flagsmith_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(flagsmith_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);





// Hook.
// -----------------------------------------------------------------------------
var useFeatureFlag = function(feature) {
    // Hooks.
    // ---------------------------------------------------------------------------
    var flags = (0,flagsmith_react__WEBPACK_IMPORTED_MODULE_1__.useFlags)([
        feature
    ]);
    var flagsmith = (0,flagsmith_react__WEBPACK_IMPORTED_MODULE_1__.useFlagsmith)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(!flagsmith.identity), isLoading = ref[0], setIsLoading = ref[1];
    // TODO: We should work with a Manfredite domain object her at some point
    var user = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(context_logged_user_loggeduser_context__WEBPACK_IMPORTED_MODULE_0__/* .LoggedUserContext */ .Vi).user;
    // Functions.
    // ---------------------------------------------------------------------------
    var identify = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var email;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(flagsmith.initialised && !flagsmith.identity && user && user.email)) return [
                        3,
                        2
                    ];
                    email = user.email;
                    return [
                        4,
                        flagsmith.identify(email, {
                            email: email,
                            manfrediteId: user.id || null
                        })
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), [
        flagsmith,
        user
    ]);
    // Effects.
    // ---------------------------------------------------------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        identify();
    }, [
        identify
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (flagsmith.initialised) {
            setIsLoading(false);
        }
    }, [
        flagsmith.identity,
        flagsmith.initialised
    ]);
    // Return
    // ---------------------------------------------------------------------------
    return {
        isEnabled: flags[feature].enabled,
        isLoading: isLoading,
        getAllTraits: flagsmith.getAllTraits,
        getTrait: flagsmith.getTrait,
        setTrait: flagsmith.setTrait
    };
};


/***/ }),

/***/ 56002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* reexport */ usePageTrack; }
});

// EXTERNAL MODULE: ./context/logged-user/loggeduser.context.tsx
var loggeduser_context = __webpack_require__(23357);
// EXTERNAL MODULE: ./hooks/useFeatureFlag/index.ts
var useFeatureFlag = __webpack_require__(84110);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./services/service.event-tracking.ts + 1 modules
var service_event_tracking = __webpack_require__(27862);
;// CONCATENATED MODULE: ./hooks/usePageTrack/usePageTrack.ts




var usePageTrack = function(event) {
    var ref = (0,react.useContext)(loggeduser_context/* LoggedUserContext */.Vi), user = ref.user, loadingUser = ref.loadingUser;
    var ref1 = (0,useFeatureFlag/* useFeatureFlag */.y)("talent_manfredite_profile_page_tracking"), isEnabled = ref1.isEnabled, isLoadingFeatureFlag = ref1.isLoading;
    var alreadySent = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        // Still loading feature flag values
        if (isLoadingFeatureFlag) {
            return;
        }
        // If event is "Public Profile - Page Loaded" and feature flag is disabled, do not track
        var isPublicProfileTrackDisabled = !isLoadingFeatureFlag && !isEnabled && event === "Public Profile - Page Loaded";
        if (isPublicProfileTrackDisabled) {
            return;
        }
        // When user info (if any) is already loaded and event is not tracked yet => Track it
        if (!alreadySent.current) {
            var urlParams = new URLSearchParams(window.location.search);
            // Identify user with campaign traits if user is logged in and campaign exists
            if (urlParams.get("utm_campaign")) {
                identifyUserWithCampaign(urlParams);
            }
            service_event_tracking/* default.page */.Z.page(event, {
                userId: (user === null || user === void 0 ? void 0 : user.id) ? "userId-".concat(user.id) : undefined
            });
            alreadySent.current = true;
        }
    }, [
        loadingUser,
        event,
        user === null || user === void 0 ? void 0 : user.id,
        isLoadingFeatureFlag,
        isEnabled
    ]);
};
function identifyUserWithCampaign(urlParams) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    service_event_tracking/* default.identifyAnonymous */.Z.identifyAnonymous({
        "campaign.name": ((ref = urlParams.get("utm_campaign")) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || undefined,
        "campaign.source": ((ref1 = urlParams.get("utm_source")) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) || undefined,
        "campaign.medium": ((ref2 = urlParams.get("utm_medium")) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) || undefined,
        "campaign.term": ((ref3 = urlParams.get("utm_term")) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()) || undefined,
        "campaign.content": ((ref4 = urlParams.get("utm_content")) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase()) || undefined,
        "campaign.id": ((ref5 = urlParams.get("utm_id")) === null || ref5 === void 0 ? void 0 : ref5.toLowerCase()) || undefined
    });
}

;// CONCATENATED MODULE: ./hooks/usePageTrack/index.ts



/***/ }),

/***/ 65812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ job_offers; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./components/shared/HeadMetadata.tsx
var HeadMetadata = __webpack_require__(73412);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ./hooks/usePageTrack/index.ts + 1 modules
var usePageTrack = __webpack_require__(56002);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/layout/Page.tsx + 19 modules
var Page = __webpack_require__(24882);
// EXTERNAL MODULE: ./components/shared/Button.js
var Button = __webpack_require__(15659);
// EXTERNAL MODULE: ./components/shared/Notification.tsx
var Notification = __webpack_require__(68870);
// EXTERNAL MODULE: ./components/shared/Spinner.tsx
var Spinner = __webpack_require__(594);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(9725);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(38914);
// EXTERNAL MODULE: ./components/shared/CustomSelect.tsx + 1 modules
var CustomSelect = __webpack_require__(88888);
// EXTERNAL MODULE: ./components/shared/FormGroup.tsx
var FormGroup = __webpack_require__(74993);
// EXTERNAL MODULE: ./components/shared/FormGroup.styled.ts
var FormGroup_styled = __webpack_require__(17975);
// EXTERNAL MODULE: ./components/shared/HelpTooltip/HelpTooltip.tsx
var HelpTooltip = __webpack_require__(73091);
// EXTERNAL MODULE: ./components/shared/HtmlTrans.tsx
var HtmlTrans = __webpack_require__(97210);
// EXTERNAL MODULE: ./components/shared/InputPlacesAutocomplete.tsx + 1 modules
var InputPlacesAutocomplete = __webpack_require__(56328);
// EXTERNAL MODULE: ./components/shared/InputText.tsx
var InputText = __webpack_require__(6776);
// EXTERNAL MODULE: ./components/shared/LinkText.tsx
var LinkText = __webpack_require__(23405);
// EXTERNAL MODULE: ./components/shared/Switcher.tsx + 1 modules
var Switcher = __webpack_require__(87603);
// EXTERNAL MODULE: ../../node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(18149);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./utils/config.ts
var config = __webpack_require__(75339);
// EXTERNAL MODULE: ./features/job-offers/list/components/JobOffersListComponent.constants.ts
var JobOffersListComponent_constants = __webpack_require__(82324);
// EXTERNAL MODULE: ../common-dto/dist/esm/index.js + 55 modules
var esm = __webpack_require__(34449);
;// CONCATENATED MODULE: ./features/job-offers/list/components/filters/Filters.constants.ts

var DEFAULT_CURRENCY_VALUE = {
    label: "€",
    value: "€"
};
var REMOTE_OPTIONS = esm/* RemoteOptionsArray.map */.iX.map(function(opt) {
    return {
        label: opt,
        value: opt
    };
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/next/dist/client/router.js
var client_router = __webpack_require__(93642);
// EXTERNAL MODULE: ./services/multilingual.service.ts
var multilingual_service = __webpack_require__(21428);
;// CONCATENATED MODULE: ./features/job-offers/list/components/filters/Filters.hooks.tsx







var useOfferListFilters = function(param) {
    var currentFilter = param.currentFilter, languages = param.languages, currencies = param.currencies, onFilterChange = param.onFilterChange, onFilterReset = param.onFilterReset;
    var t = (0,useI18n/* useI18n */.Q)("job-offer-list").t;
    var router = (0,client_router.useRouter)();
    var languageValues = (0,react.useMemo)(function() {
        return [
            {
                label: t("any_language"),
                value: ""
            }
        ].concat((0,_to_consumable_array/* default */.Z)(languages.map(function(l) {
            return {
                label: (0,multilingual_service/* getTranslatedText */.G)(l.name, router.locale),
                value: l.code
            };
        })));
    }, [
        languages,
        router.locale,
        t
    ]);
    var currencyValues = (0,react.useMemo)(function() {
        var values = currencies.map(function(param) {
            var symbol = param.symbol, label = param.label;
            return {
                label: symbol,
                value: symbol,
                title: label
            };
        });
        values.splice(2, 0, {
            label: "---",
            value: "",
            title: ""
        });
        return values;
    }, [
        currencies
    ]);
    var updateFilter = (0,react.useCallback)(function(newFilter) {
        onFilterChange(newFilter);
    }, [
        onFilterChange
    ]);
    var handleResetFiltersClick = (0,react.useCallback)(function() {
        onFilterReset();
    }, [
        onFilterReset
    ]);
    var getLabelValueForCurrentFilterLanguages = (0,react.useCallback)(function() {
        if (currentFilter.offerLanguage) {
            var selectedLanguage = languages.find(function(language) {
                return language.code === currentFilter.offerLanguage;
            });
            return {
                label: (0,multilingual_service/* getTranslatedText */.G)(selectedLanguage === null || selectedLanguage === void 0 ? void 0 : selectedLanguage.name, router.locale),
                value: (selectedLanguage === null || selectedLanguage === void 0 ? void 0 : selectedLanguage.code) || ""
            };
        } else {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, languageValues[0]), {
                label: languageValues[0].label
            });
        }
    }, [
        currentFilter.offerLanguage,
        languageValues,
        languages,
        router.locale
    ]);
    return {
        t: t,
        currencyValues: currencyValues,
        languageValues: languageValues,
        getLabelValueForCurrentFilterLanguages: getLabelValueForCurrentFilterLanguages,
        handleResetFiltersClick: handleResetFiltersClick,
        updateFilter: updateFilter
    };
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./components/shared/accordion/Accordion.styled.tsx
var Accordion_styled = __webpack_require__(28619);
// EXTERNAL MODULE: ./components/shared/InputText.styled.ts
var InputText_styled = __webpack_require__(56524);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./features/job-offers/list/components/filters/Filters.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  width: 260px;\n  z-index: ",
        ";\n  transform: translateX(100%);\n  transition: transform 0.3s, visibility 0.3s;\n  background-color: ",
        ";\n  visibility: hidden;\n\n  .showFilters & {\n    transform: translateX(0);\n    visibility: visible;\n  }\n\n  @media (min-width: ",
        ") {\n    position: static;\n    width: auto;\n    transform: unset;\n    background-color: unset;\n    visibility: visible;\n  }\n\n  ",
        " {\n    padding: ",
        " 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .showFilters & {\n    background-color: rgba(0, 0, 0, 0.2);\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    z-index: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: ",
        ";\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n\n  @media (min-width: ",
        ") {\n    background-color: transparent;\n    padding: 0 0 ",
        " 0;\n    text-transform: uppercase;\n    letter-spacing: 0.25em;\n    color: ",
        ";\n    font-size: ",
        ";\n    border-bottom: 1px solid ",
        ";\n\n    ",
        ".close-filters {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n  padding: ",
        ";\n  overflow: auto;\n\n  .filters-item:not(:last-child) {\n    margin-bottom: ",
        ";\n  }\n\n  input[type='number'] {\n    width: ",
        ";\n    min-width: auto;\n    -moz-appearance: textfield;\n\n    &::-webkit-outer-spin-button,\n    &::-webkit-inner-spin-button {\n      -webkit-appearance: none;\n      margin: 0;\n    }\n  }\n\n  @media (min-width: ",
        ") {\n    padding: ",
        " 0;\n    overflow: visible;\n  }\n\n  ",
        " {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: ",
        " ",
        " ",
        " ",
        ";\n  margin-top: 0;\n\n  ",
        " {\n    display: flex;\n    width: 100%;\n    margin-bottom: ",
        ";\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  @media (min-width: ",
        ") {\n    background-color: transparent;\n    padding: 0;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: center;\n  width: ",
        ";\n  height: ",
        ";\n  background: red;\n  animation: spin 0.75s linear infinite;\n  border-radius: 50%;\n  background: linear-gradient(\n    to right,\n    #ffffff 10%,\n    rgba(255, 255, 255, 0) 42%\n  );\n  position: absolute;\n  right: 0;\n  bottom: 0;\n\n  &:before {\n    width: 50%;\n    height: 50%;\n    background: ",
        ";\n    border-radius: 100% 0 0 0;\n    position: absolute;\n    top: 0;\n    left: 0;\n    content: '';\n  }\n  &:after {\n    background: #fff;\n    width: 75%;\n    height: 75%;\n    border-radius: 50%;\n    content: '';\n    margin: auto;\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n  }\n\n  @keyframes spin {\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n  border: 0;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n\n  ",
        " {\n    width: auto;\n  }\n\n  .mf-select {\n    width: 5rem;\n  }\n  .mf-select__control {\n    border-top-right-radius: 0 !important;\n    border-bottom-right-radius: 0 !important;\n    border-right: 0 !important;\n  }\n\n  ",
        " {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}






var StyledFilters = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e2fb216-0"
})(_templateObject(), (0,theme/* zindex */.Y0)("filters"), (0,theme/* color */.$_)("white"), (0,theme/* screen */.sp)("lg"), Accordion_styled/* StyledContent */.Hz, (0,theme/* spacing */.W0)("md"));
var StyledFiltersBg = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e2fb216-1"
})(_templateObject1(), (0,theme/* zindex */.Y0)("filtersBg"), (0,theme/* screen */.sp)("lg"));
var StyledOfferAlertsDropdown = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e2fb216-2"
})(_templateObject2());
var StyledFiltersTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e2fb216-3"
})(_templateObject3(), (0,theme/* color */.$_)("midnight_100"), (0,theme/* spacing */.W0)("md"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("sm"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* color */.$_)("midnight_300"), Button/* Button */.z);
var StyledFiltersContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e2fb216-4"
})(_templateObject4(), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("lg"), Accordion_styled/* StyledAccordion */.sB, (0,theme/* spacing */.W0)("lg"));
var StyledFiltersAction = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e2fb216-5"
})(_templateObject5(), (0,theme/* color */.$_)("midnight_100"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("md"), Button/* Button */.z, (0,theme/* spacing */.W0)("sm"), (0,theme/* screen */.sp)("lg"));
var StyledListFilterSpinner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e2fb216-6"
})(_templateObject6(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* color */.$_)("midnight_800"));
var StyledSalaryFieldset = styled_components_browser_esm/* default.fieldset.withConfig */.ZP.fieldset.withConfig({
    componentId: "sc-e2fb216-7"
})(_templateObject7());
var StyledSalaryDoubleField = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e2fb216-8"
})(_templateObject8(), FormGroup_styled/* StyledFormGroup */.dS, InputText_styled/* StyledInputText */.iY);

;// CONCATENATED MODULE: ./features/job-offers/list/components/filters/Filters.tsx


























var Filters = function(param) {
    var currentFilter = param.currentFilter, isSavingOfferAlert = param.isSavingOfferAlert, currencies = param.currencies, languages = param.languages, techs = param.techs, techRoles = param.techRoles, allLanguages = param.allLanguages, onFilterChange = param.onFilterChange, onFilterReset = param.onFilterReset, onManageAlertsClick = param.onManageAlertsClick, onCreateAlertClick = param.onCreateAlertClick, onClose = param.onClose, className = param.className;
    var ref, ref1;
    var ref2 = useOfferListFilters({
        currencies: currencies,
        currentFilter: currentFilter,
        languages: languages,
        onFilterChange: onFilterChange,
        onFilterReset: onFilterReset
    }), t = ref2.t, currencyValues = ref2.currencyValues, languageValues = ref2.languageValues, getLabelValueForCurrentFilterLanguages = ref2.getLabelValueForCurrentFilterLanguages, handleResetFiltersClick = ref2.handleResetFiltersClick, updateFilter = ref2.updateFilter;
    var locale = (0,router.useRouter)().locale;
    // Alerts can only be created if some "saveable" filters are applied
    // (meaning that they are different from the default filters)
    // currency and onlyActive are not considered "saveable" filters.
    var userCanCreateAlerts = (0,react.useMemo)(function() {
        return !isEqual_default()({
            locations: currentFilter.locations || JobOffersListComponent_constants/* DEFAULT_FILTER.locations */.XW.locations,
            minLanguages: currentFilter.minLanguages || JobOffersListComponent_constants/* DEFAULT_FILTER.minLanguages */.XW.minLanguages,
            minSalary: currentFilter.minSalary || JobOffersListComponent_constants/* DEFAULT_FILTER.minSalary */.XW.minSalary,
            offerLanguage: currentFilter.offerLanguage || JobOffersListComponent_constants/* DEFAULT_FILTER.offerLanguage */.XW.offerLanguage,
            remoteOptions: currentFilter.remoteOptions || JobOffersListComponent_constants/* DEFAULT_FILTER.remoteOptions */.XW.remoteOptions,
            techRoles: currentFilter.techRoles || JobOffersListComponent_constants/* DEFAULT_FILTER.techRoles */.XW.techRoles,
            techs: currentFilter.techs || JobOffersListComponent_constants/* DEFAULT_FILTER.techs */.XW.techs,
            text: currentFilter.text || JobOffersListComponent_constants/* DEFAULT_FILTER.text */.XW.text,
            currency: undefined,
            onlyActive: undefined
        }, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, JobOffersListComponent_constants/* DEFAULT_FILTER */.XW), {
            currency: undefined,
            onlyActive: undefined
        }));
    }, [
        currentFilter.locations,
        currentFilter.minLanguages,
        currentFilter.minSalary,
        currentFilter.offerLanguage,
        currentFilter.remoteOptions,
        currentFilter.techRoles,
        currentFilter.techs,
        currentFilter.text
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFiltersBg, {
                onClick: onClose
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFilters, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFiltersTitle, {
                        children: [
                            t("filters_title"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                sizes: "sm",
                                variant: "tertiary",
                                isIcon: true,
                                onClick: onClose,
                                className: "close-filters",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: pro_light_svg_icons/* faTimes */.NBC
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFiltersContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Switcher/* default */.Z, {
                                id: "activeOffers",
                                label: t("only_active"),
                                onChange: function(e) {
                                    return updateFilter((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, currentFilter), {
                                        onlyActive: e.target.checked
                                    }));
                                },
                                checked: currentFilter.onlyActive,
                                className: "filters-item"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* default */.Z, {
                                label: t("techRoles"),
                                helpContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                    ns: "job-offer-list",
                                    i18nKey: "filters_tooltips.roles",
                                    components: {
                                        rolesLink: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkText/* LinkText */.u, {
                                            href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.roles */.uu.roles, locale)
                                        })
                                    }
                                }),
                                forId: "techRoles",
                                className: "filters-item",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSelect/* default */.Z, {
                                    id: "techRoles",
                                    isSmall: true,
                                    value: (ref = currentFilter.techRoles) === null || ref === void 0 ? void 0 : ref.map(function(techRoleId) {
                                        return techRoles.find(function(el) {
                                            return el.value === techRoleId;
                                        });
                                    }),
                                    options: techRoles,
                                    onChange: function(selectedOptions) {
                                        updateFilter((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, currentFilter), {
                                            techRoles: selectedOptions.map(function(opt) {
                                                return +opt.value;
                                            })
                                        }));
                                    },
                                    isMulti: true,
                                    hideDropdownUntilSearch: true,
                                    placeholder: t("techRoles_placeholder")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* default */.Z, {
                                label: t("techs"),
                                helpContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                    ns: "job-offer-list",
                                    i18nKey: "filters_tooltips.techs",
                                    components: {
                                        supportLink: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "mailto:".concat(config/* config.supportEmail */.v.supportEmail),
                                            target: "_blank",
                                            rel: "noreferrer"
                                        })
                                    },
                                    values: {
                                        email: config/* config.supportEmail */.v.supportEmail
                                    }
                                }),
                                forId: "techs",
                                className: "filters-item",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSelect/* default */.Z, {
                                    id: "techs",
                                    isSmall: true,
                                    value: (ref1 = currentFilter.techs) === null || ref1 === void 0 ? void 0 : ref1.map(function(techId) {
                                        return techs.find(function(el) {
                                            return el.value === techId;
                                        });
                                    }),
                                    options: techs,
                                    matchFrom: "start",
                                    onChange: function(selectedOptions) {
                                        updateFilter((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, currentFilter), {
                                            techs: selectedOptions.map(function(opt) {
                                                return +opt.value;
                                            })
                                        }));
                                    },
                                    isMulti: true,
                                    hideDropdownUntilSearch: true,
                                    placeholder: t("techs_placeholder"),
                                    multiValueSeparator: "or"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* default */.Z, {
                                label: t("text"),
                                helpContent: t("filters_tooltips.text"),
                                forId: "offerSearch",
                                className: "filters-item",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputText/* default */.Z, {
                                    id: "offerSearch",
                                    type: "text",
                                    placeholder: t("text_placeholder"),
                                    title: t("text_title"),
                                    sizes: "sm",
                                    value: currentFilter.text,
                                    onChange: function(e) {
                                        return updateFilter((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, currentFilter), {
                                            text: e.target.value
                                        }));
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSalaryFieldset, {
                                className: "filters-item",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormGroup_styled/* StyledFormGroupLabelWrapper */.Z2, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormGroup_styled/* StyledFormGroupLabel */.kI, {
                                                as: "legend",
                                                children: [
                                                    t("min_salary"),
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpTooltip/* HelpTooltip */.k, {
                                                message: t("filters_tooltips.minSalary")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSalaryDoubleField, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* default */.Z, {
                                                label: "Select currency",
                                                forId: "salaryCurrency",
                                                isLabelHidden: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSelect/* default */.Z, {
                                                    id: "salaryCurrency",
                                                    placeholder: "€",
                                                    options: currencyValues,
                                                    isSmall: true,
                                                    value: currentFilter.currency ? {
                                                        label: currentFilter.currency,
                                                        value: currentFilter.currency
                                                    } : DEFAULT_CURRENCY_VALUE,
                                                    onChange: function(selection) {
                                                        return updateFilter((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, currentFilter), {
                                                            currency: selection.value
                                                        }));
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* default */.Z, {
                                                label: t("min_salary"),
                                                forId: "minSalary",
                                                isLabelHidden: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputText/* default */.Z, {
                                                    id: "minSalary",
                                                    type: "number",
                                                    step: "any",
                                                    min: 0,
                                                    placeholder: t("min_salary_placeholder"),
                                                    title: t("min_salary_title"),
                                                    variant: "thousands",
                                                    onChange: function(e) {
                                                        return updateFilter((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, currentFilter), {
                                                            minSalary: e.target.value
                                                        }));
                                                    },
                                                    sizes: "sm",
                                                    value: currentFilter.minSalary,
                                                    onKeyDown: function(e) {
                                                        if (isNaN(+e.key) && e.key !== "Backspace") e.preventDefault();
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* default */.Z, {
                                label: t("remote_options"),
                                helpContent: t("filters_tooltips.remotePercentage"),
                                forId: "remoteOtions",
                                className: "filters-item",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSelect/* default */.Z, {
                                    id: "remoteOtions",
                                    isSmall: true,
                                    value: REMOTE_OPTIONS.filter(function(opt) {
                                        var ref;
                                        return (ref = currentFilter.remoteOptions) === null || ref === void 0 ? void 0 : ref.includes(opt.value);
                                    }),
                                    options: REMOTE_OPTIONS,
                                    formatOptionLabel: function(opt) {
                                        return t("remote_options_items.".concat(opt));
                                    },
                                    onChange: function(selectedOptions) {
                                        updateFilter((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, currentFilter), {
                                            remoteOptions: selectedOptions.map(function(opt) {
                                                return opt.value;
                                            })
                                        }));
                                    },
                                    isMulti: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* default */.Z, {
                                label: t("location"),
                                helpContent: t("filters_tooltips.location"),
                                forId: "location",
                                className: "filters-item",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputPlacesAutocomplete/* default */.Z, {
                                    isSmall: true,
                                    value: currentFilter.locations,
                                    autocompleteTypes: [
                                        "locality"
                                    ],
                                    onChange: function(place) {
                                        var locations = place;
                                        updateFilter((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, currentFilter), {
                                            locations: locations
                                        }));
                                    },
                                    isMulti: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* default */.Z, {
                                label: t("language"),
                                helpContent: t("filters_tooltips.languages"),
                                forId: "language",
                                className: "filters-item",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSelect/* default */.Z, {
                                    id: "language",
                                    placeholder: t("any_language"),
                                    defaultValue: languageValues[0],
                                    options: languageValues,
                                    value: getLabelValueForCurrentFilterLanguages(),
                                    isSmall: true,
                                    onChange: function(selection) {
                                        return updateFilter((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, currentFilter), {
                                            offerLanguage: selection.value
                                        }));
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFiltersAction, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                                sizes: "xs",
                                variant: "primary",
                                isLoading: isSavingOfferAlert,
                                className: "alerts",
                                onClick: onCreateAlertClick,
                                disabled: !userCanCreateAlerts,
                                children: [
                                    !isSavingOfferAlert && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: pro_solid_svg_icons/* faBellPlus */.t$x
                                    }),
                                    isSavingOfferAlert && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: pro_solid_svg_icons/* faSpinnerThird */.AX7,
                                        spin: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: t("create_alert")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                                sizes: "xs",
                                variant: "secondary",
                                className: "alerts",
                                onClick: onManageAlertsClick,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: pro_solid_svg_icons/* faTools */.CgH
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: t("open_alerts")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                                sizes: "xs",
                                variant: "secondary",
                                onClick: handleResetFiltersClick,
                                disabled: !userCanCreateAlerts,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: free_solid_svg_icons/* faCircleXmark */.WA2
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: t("reset_filter")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var filters_Filters = (Filters);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(42838);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./context/logged-user/loggeduser.context.tsx
var loggeduser_context = __webpack_require__(23357);
// EXTERNAL MODULE: ./hooks/useToasts/useToasts.ts
var useToasts = __webpack_require__(57064);
// EXTERNAL MODULE: ./model/index.ts + 29 modules
var model = __webpack_require__(41400);
// EXTERNAL MODULE: ./services/service-offer-alert.ts + 2 modules
var service_offer_alert = __webpack_require__(33917);
// EXTERNAL MODULE: ./services/service.event-tracking.ts + 1 modules
var service_event_tracking = __webpack_require__(27862);
// EXTERNAL MODULE: ./services/service.web-offer.ts + 3 modules
var service_web_offer = __webpack_require__(93814);
// EXTERNAL MODULE: ../../node_modules/use-debounce/esm/useDebouncedCallback.js
var useDebouncedCallback = __webpack_require__(60669);
// EXTERNAL MODULE: ./utils/job-offers-filter.ts
var job_offers_filter = __webpack_require__(55920);
// EXTERNAL MODULE: ./utils/localize.utils.ts
var localize_utils = __webpack_require__(38062);
// EXTERNAL MODULE: ./utils/router.ts
var utils_router = __webpack_require__(79546);
// EXTERNAL MODULE: ./services/service.language.normalizer.ts
var service_language_normalizer = __webpack_require__(37031);
;// CONCATENATED MODULE: ./features/job-offers/list/components/filters/Filters.adapter.ts


// Public methods
// ----------------------------------------------------------------------------
function normalizeToOfferAlertCreateRequest(filter, lang) {
    return {
        currency: getCurrencyFieldFromFilter(filter),
        remoteOptions: getRemoteOptionsFieldFromFilter(filter),
        locations: getLocationsFieldFromFilter(filter),
        techs: getTechsFieldFromFilter(filter),
        techRoles: getTechRolesFieldFromFilter(filter),
        offerLanguage: getOfferLanguageFieldFromFilter(filter),
        minSalary: getMinSalaryFieldFromFilter(filter),
        text: getTextFieldFromFilter(filter),
        minLanguages: getMinLanguagesFieldFromFilter(filter),
        lang: lang
    };
}
// Private functions
// ----------------------------------------------------------------------------
function getCurrencyFieldFromFilter(filter) {
    return filter.currency || "€";
}
function getRemoteOptionsFieldFromFilter(filter) {
    var ref;
    var options = ((ref = filter.remoteOptions) === null || ref === void 0 ? void 0 : ref.filter(Boolean)) || [];
    return options.length > 0 ? options : [];
}
function getMinLanguagesFieldFromFilter(filter) {
    var ref;
    var minLangs = ((ref = filter.minLanguages) === null || ref === void 0 ? void 0 : ref.filter(Boolean).map(function(minLang) {
        return {
            languageId: minLang.language.value,
            level: service_language_normalizer/* LanguageLevelToCommonDtoLevelDict */.rF[minLang.level.value]
        };
    })) || [];
    return minLangs.length > 0 ? minLangs : [];
}
function getLocationsFieldFromFilter(filter) {
    var ref;
    var locations = ((ref = filter.locations) === null || ref === void 0 ? void 0 : ref.map(function(c) {
        return (c === null || c === void 0 ? void 0 : c.placeId) || "";
    }).filter(function(c) {
        return !!c;
    })) || [];
    return locations.length > 0 ? locations : [];
}
function getTechsFieldFromFilter(filter) {
    var ref;
    var techs = ((ref = filter.techs) === null || ref === void 0 ? void 0 : ref.filter(Boolean)) || [];
    return techs.length > 0 ? techs : [];
}
function getTechRolesFieldFromFilter(filter) {
    var ref;
    var techRoles = ((ref = filter.techRoles) === null || ref === void 0 ? void 0 : ref.filter(Boolean)) || [];
    return techRoles.length > 0 ? techRoles : [];
}
function getOfferLanguageFieldFromFilter(filter) {
    return filter.offerLanguage ? (0,localize_utils/* getLocale */.K)(filter.offerLanguage) : undefined;
}
function getMinSalaryFieldFromFilter(filter) {
    return filter.minSalary ? +filter.minSalary : undefined;
}
function getTextFieldFromFilter(filter) {
    return filter.text || undefined;
}

// EXTERNAL MODULE: ../../node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(45455);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./services/ui/offer.service.ts
var offer_service = __webpack_require__(58630);
// EXTERNAL MODULE: ./utils/job-offers-filter.constants.ts
var job_offers_filter_constants = __webpack_require__(72933);
;// CONCATENATED MODULE: ./features/job-offers/list/components/JobOffersListComponent.utils.ts






function getTextForOffersListFilter(param) {
    var filter = param.filter, t = param.t, languages = param.languages, allMinLanguages = param.allMinLanguages, techs = param.techs, locale = param.locale;
    var filtersText = [];
    if (filter.onlyActive) {
        filtersText.push(t("filters_onlyActive"));
    }
    if (filter.remoteOptions && filter.remoteOptions.length > 0) {
        filtersText.push(t("filters_remoteOptionsRemote", {
            remotePercentage: REMOTE_OPTIONS.filter(function(opt) {
                var ref;
                return (ref = filter.remoteOptions) === null || ref === void 0 ? void 0 : ref.includes(opt.value);
            }).map(function(opt) {
                return t("remote_options_items.".concat(opt.label));
            }).filter(Boolean).join(", ")
        }));
    }
    if (filter.techs && filter.techs.length > 0) {
        filtersText.push(t("filters_techs", {
            techs: techs.filter(function(opt) {
                var ref;
                return (ref = filter.techs) === null || ref === void 0 ? void 0 : ref.includes(+opt.value);
            }).map(function(opt) {
                return opt.label;
            }).filter(Boolean).join(", ")
        }));
    }
    if (filter.locations && filter.locations.length > 0) {
        filtersText.push(t("filters_city", {
            city: (0,offer_service/* getCityStringFromUIPlacesAutocompleteItem */.Wl)(filter.locations, locale)
        }));
    }
    if (filter.text) {
        filtersText.push(t("filters_text", {
            text: filter.text
        }));
    }
    if (filter.currency && filter.minSalary) {
        filtersText.push(t("filters_minSalary", {
            minSalary: filter.minSalary,
            currency: filter.currency
        }));
    }
    if (filter.minLanguages) {
        filtersText.push(t("filters_minLanguages", {
            minLanguages: filter.minLanguages.map(function(minLang) {
                var ref;
                return "".concat((ref = allMinLanguages.find(function(lang) {
                    return lang.value === minLang.language.value;
                })) === null || ref === void 0 ? void 0 : ref.label, " (").concat(t("language-selector.level.options." + minLang.level.label, {
                    ns: "common"
                }), ")");
            }).join(", ")
        }));
    }
    if (filter.offerLanguage) {
        filtersText.push(t("filters_language", {
            language: getValueForCurrentFilterLanguages(filter, languages, locale)
        }));
    }
    return filtersText;
}
function hasFiltersInUrlParams(params) {
    return job_offers_filter_constants/* OFFER_FILTER_QUERY_PARAMS.some */.oZ.some(function(param) {
        return !isEmpty_default()(params.get(param));
    });
}
function checkIsDefaultFilter(filter) {
    var hasCityFilter = !isEmpty_default()(filter === null || filter === void 0 ? void 0 : filter.locations);
    var hasRemoteOptionsFilter = !isEmpty_default()(filter === null || filter === void 0 ? void 0 : filter.remoteOptions);
    var hasTechsFilter = !isEmpty_default()(filter === null || filter === void 0 ? void 0 : filter.techs);
    var hasTechRolesFilter = !isEmpty_default()(filter === null || filter === void 0 ? void 0 : filter.techRoles);
    var hasMinLanguagesFilter = !isEmpty_default()(filter === null || filter === void 0 ? void 0 : filter.minLanguages);
    return (filter === null || filter === void 0 ? void 0 : filter.currency) === JobOffersListComponent_constants/* DEFAULT_FILTER.currency */.XW.currency && (filter === null || filter === void 0 ? void 0 : filter.onlyActive) === JobOffersListComponent_constants/* DEFAULT_FILTER.onlyActive */.XW.onlyActive && !hasCityFilter && !hasRemoteOptionsFilter && !hasTechsFilter && !hasTechRolesFilter && !hasMinLanguagesFilter && !(filter === null || filter === void 0 ? void 0 : filter.minSalary) && !(filter === null || filter === void 0 ? void 0 : filter.offerLanguage) && !(filter === null || filter === void 0 ? void 0 : filter.text);
}
function getValueForCurrentFilterLanguages(filter, languages, locale) {
    if (filter.offerLanguage) {
        var selectedLanguage = languages.find(function(language) {
            return language.code === filter.offerLanguage;
        });
        return (0,multilingual_service/* getTranslatedText */.G)(selectedLanguage === null || selectedLanguage === void 0 ? void 0 : selectedLanguage.name, locale);
    } else {
        return "";
    }
}

;// CONCATENATED MODULE: ./features/job-offers/list/components/JobOffersListComponent.hooks.tsx


























var useJobOffersList = function(param) {
    var languages = param.languages, allLanguages = param.allLanguages, techs = param.techs;
    var setupFilterText = function setupFilterText(filter) {
        var text = getTextForOffersListFilter({
            filter: filter,
            t: t,
            languages: languages,
            allMinLanguages: allLanguages,
            techs: techs,
            locale: locale
        });
        setCurrentFiltersText(text);
    };
    var router = (0,client_router.useRouter)();
    var t = (0,useI18n/* useI18n */.Q)("job-offer-list").t;
    var locale = router.locale;
    var ref = (0,react.useState)(JobOffersListComponent_constants/* DEFAULT_FILTER */.XW), currentFilters = ref[0], setCurrentFilters = ref[1];
    var ref1 = (0,react.useState)([]), UIOffers = ref1[0], setUIOffers = ref1[1];
    var ref2 = (0,react.useState)([]), currentFiltersText = ref2[0], setCurrentFiltersText = ref2[1];
    var ref3 = (0,react.useState)(true), loading = ref3[0], setLoading = ref3[1];
    var ref4 = (0,react.useState)(false), activeFilters = ref4[0], setActiveFilters = ref4[1];
    var ref5 = (0,react.useState)(true), filtersDesktop = ref5[0], setFiltersDesktop = ref5[1];
    var isDefaultFilter = (0,react.useMemo)(function() {
        return checkIsDefaultFilter(currentFilters);
    }, [
        currentFilters
    ]);
    var filterOffersDebounced = (0,useDebouncedCallback/* default */.Z)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(filter) {
            var loadingDelay, filteredOffers;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setupFilterText(filter);
                        loadingDelay = setTimeout(function() {
                            setLoading(true);
                        }, JobOffersListComponent_constants/* LOADING_AFTER_MILLIS */.ge);
                        return [
                            4,
                            service_web_offer/* ServiceWebOffer.getAllSummary */.u.getAllSummary(filter, locale === null || locale === void 0 ? void 0 : locale.toUpperCase())
                        ];
                    case 1:
                        filteredOffers = _state.sent();
                        (0,job_offers_filter/* setUrlQueryParamsFromJobOffersFilter */.j_)({
                            filter: filter,
                            router: router
                        });
                        clearTimeout(loadingDelay);
                        setUIOffers(filteredOffers);
                        setLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function(filter) {
            return _ref.apply(this, arguments);
        };
    }(), JobOffersListComponent_constants/* DEBOUNCE_FILTER_OFFERS_TIME_IN_MILLIS */.Ax);
    var handleOnFilterChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(filter) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (filter.minSalary && +filter.minSalary < 0) {
                    return [
                        2
                    ];
                }
                setCurrentFilters(filter);
                filterOffersDebounced(filter);
                return [
                    2
                ];
            });
        });
        return function handleOnFilterChange(filter) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleOnFilterReset = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                handleOnFilterChange(JobOffersListComponent_constants/* DEFAULT_FILTER */.XW);
                return [
                    2
                ];
            });
        });
        return function handleOnFilterReset() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var isFiltersDesktop = function isFiltersDesktop() {
            setFiltersDesktop(window.matchMedia("(min-width: 1056px)").matches);
        };
        isFiltersDesktop();
        window.addEventListener("resize", isFiltersDesktop);
        return function() {
            window.removeEventListener("resize", isFiltersDesktop);
        };
    }, []);
    (0,react.useEffect)(function() {
        var checkQueryParams = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var urlSearchParams, filtersFromUrl, isDefaultFilter;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            urlSearchParams = new URLSearchParams(window.location.search);
                            service_event_tracking/* default.track */.Z.track({
                                type: "Offers - List Viewed",
                                properties: {
                                    pageLanguage: locale
                                }
                            });
                            if (!hasFiltersInUrlParams(urlSearchParams)) return [
                                3,
                                1
                            ];
                            filtersFromUrl = (0,job_offers_filter/* getFilterFromUrlParams */.LB)(urlSearchParams);
                            isDefaultFilter = checkIsDefaultFilter(filtersFromUrl);
                            setCurrentFilters(filtersFromUrl);
                            if (!isDefaultFilter) {
                                setupFilterText(filtersFromUrl);
                            }
                            handleOnFilterChange(filtersFromUrl);
                            return [
                                3,
                                3
                            ];
                        case 1:
                            setCurrentFilters(JobOffersListComponent_constants/* DEFAULT_FILTER */.XW);
                            return [
                                4,
                                (0,job_offers_filter/* setUrlQueryParamsFromJobOffersFilter */.j_)({
                                    filter: JobOffersListComponent_constants/* DEFAULT_FILTER */.XW,
                                    router: router
                                })
                            ];
                        case 2:
                            _state.sent();
                            handleOnFilterChange(JobOffersListComponent_constants/* DEFAULT_FILTER */.XW);
                            _state.label = 3;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function checkQueryParams() {
                return _ref.apply(this, arguments);
            };
        }();
        checkQueryParams();
    }, []);
    return {
        t: t,
        UIOffers: UIOffers,
        currentFilters: currentFilters,
        currentFiltersText: currentFiltersText,
        loading: loading,
        activeFilters: activeFilters,
        setActiveFilters: setActiveFilters,
        filtersDesktop: filtersDesktop,
        isDefaultFilter: isDefaultFilter,
        handleOnFilterChange: handleOnFilterChange,
        handleOnFilterReset: handleOnFilterReset
    };
};
var useJobOffersAlerts = function(param) {
    var currentFilters = param.currentFilters;
    var getOfferAlertToRemove = function getOfferAlertToRemove(params) {
        return params.get(JobOffersListComponent_constants/* UNSUSCRIBE_ALERT_PARAM */.P4);
    };
    var hasManageOfferAlerts = function hasManageOfferAlerts(params) {
        return params.get(JobOffersListComponent_constants/* OPEN_ALERT_PARAM */.E0) !== null && params.get(JobOffersListComponent_constants/* OPEN_ALERT_PARAM */.E0) !== "" || params.get(JobOffersListComponent_constants/* UNSUSCRIBE_ALERT_PARAM */.P4) !== null && params.get(JobOffersListComponent_constants/* UNSUSCRIBE_ALERT_PARAM */.P4) !== "";
    };
    var ref;
    var t = (0,useI18n/* useI18n */.Q)("job-offer-list").t;
    var router = (0,client_router.useRouter)();
    var locale = router.locale;
    var user = (0,react.useContext)(loggeduser_context/* LoggedUserContext */.Vi).user;
    var ref1 = (0,useToasts/* useToasts */.e)(), addErrorToast = ref1.addErrorToast, addSuccessToast = ref1.addSuccessToast;
    var ref2 = (0,react.useState)([]), alerts = ref2[0], setAlerts = ref2[1];
    var ref3 = (0,react.useState)(false), isManageAlertsModalOpened = ref3[0], setIsManageAlertsModalOpened = ref3[1];
    var ref4 = (0,react.useState)(null), unsuscribeActionOfferAlert = ref4[0], setUnsuscribeActionOfferAlert = ref4[1];
    var ref5 = (0,react.useState)(false), isConfirmSaveModalOpened = ref5[0], setIsConfirmSaveModalOpened = ref5[1];
    var ref6 = (0,react.useState)(false), isSavingAlert = ref6[0], setIsSavingAlert = ref6[1];
    // Alerts can only be created if some "saveable" filters are applied
    // (meaning that they are different from the default filters)
    // currency and onlyActive are not considered "saveable" filters.
    var userCanCreateAlerts = (0,react.useMemo)(function() {
        return !isEqual_default()({
            locations: currentFilters.locations || JobOffersListComponent_constants/* DEFAULT_FILTER.locations */.XW.locations,
            minLanguages: currentFilters.minLanguages || JobOffersListComponent_constants/* DEFAULT_FILTER.minLanguages */.XW.minLanguages,
            minSalary: currentFilters.minSalary || JobOffersListComponent_constants/* DEFAULT_FILTER.minSalary */.XW.minSalary,
            offerLanguage: currentFilters.offerLanguage || JobOffersListComponent_constants/* DEFAULT_FILTER.offerLanguage */.XW.offerLanguage,
            remoteOptions: currentFilters.remoteOptions || JobOffersListComponent_constants/* DEFAULT_FILTER.remoteOptions */.XW.remoteOptions,
            techRoles: currentFilters.techRoles || JobOffersListComponent_constants/* DEFAULT_FILTER.techRoles */.XW.techRoles,
            techs: currentFilters.techs || JobOffersListComponent_constants/* DEFAULT_FILTER.techs */.XW.techs,
            text: currentFilters.text || JobOffersListComponent_constants/* DEFAULT_FILTER.text */.XW.text,
            currency: undefined,
            onlyActive: undefined
        }, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, JobOffersListComponent_constants/* DEFAULT_FILTER */.XW), {
            currency: undefined,
            onlyActive: undefined
        }));
    }, [
        currentFilters.locations,
        currentFilters.minLanguages,
        currentFilters.minSalary,
        currentFilters.offerLanguage,
        currentFilters.remoteOptions,
        currentFilters.techRoles,
        currentFilters.techs,
        currentFilters.text
    ]);
    (0,react.useEffect)(function() {
        function fetchAlerts() {
            return _fetchAlerts.apply(this, arguments);
        }
        function _fetchAlerts() {
            _fetchAlerts = (0,_async_to_generator/* default */.Z)(function() {
                var manfrediteOfferAlerts, ex;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!user) {
                                return [
                                    2
                                ];
                            }
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                service_offer_alert/* default.getAll */.Z.getAll((0,localize_utils/* getLocale */.K)(locale))
                            ];
                        case 2:
                            manfrediteOfferAlerts = _state.sent();
                            setAlerts(manfrediteOfferAlerts);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            ex = _state.sent();
                            if ((0,_instanceof/* default */.Z)(ex, model/* FetchError */.kp) && ex.statusCode >= 500) {
                                console.error("Could not get Manfredite alerts. Exception: ".concat(ex), ex);
                            }
                            setAlerts([]);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return _fetchAlerts.apply(this, arguments);
        }
        fetchAlerts();
    }, [
        user
    ]);
    (0,react.useEffect)(function() {
        var urlSearchParams = new URLSearchParams(window.location.search);
        if (hasManageOfferAlerts(urlSearchParams)) {
            setIsManageAlertsModalOpened(true);
            setTimeout(function() {
                (0,utils_router/* removeQueryParamsFromRouter */.q)(router, [
                    JobOffersListComponent_constants/* OPEN_ALERT_PARAM */.E0
                ]);
            }, 500);
        }
        var offerAlertToRemove = getOfferAlertToRemove(urlSearchParams);
        if (offerAlertToRemove) {
            setIsManageAlertsModalOpened(true);
            setUnsuscribeActionOfferAlert(offerAlertToRemove);
            setTimeout(function() {
                (0,utils_router/* removeQueryParamsFromRouter */.q)(router, [
                    JobOffersListComponent_constants/* OPEN_ALERT_PARAM */.E0,
                    JobOffersListComponent_constants/* UNSUSCRIBE_ALERT_PARAM */.P4
                ]);
            }, 500);
        }
    }, []);
    var handleOpenManageAlertsClick = (0,react.useCallback)(function() {
        setIsManageAlertsModalOpened(true);
    }, []);
    var handleSignupClick = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var params, returnUrl, signupPath, url;
        return (0,tslib_es6.__generator)(this, function(_state) {
            params = new URLSearchParams(window.location.search);
            params.set("action", "create-alert");
            returnUrl = "/".concat(locale).concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.jobOffers */.uu.jobOffers, locale), "?").concat(params);
            signupPath = "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.join */.uu.join, locale), "?returnUrl=").concat(encodeURIComponent(returnUrl));
            url = "".concat(window.location.origin, "/").concat(locale).concat(signupPath);
            window.location.replace(url);
            return [
                2
            ];
        });
    }), [
        locale
    ]);
    var handleCreateAlertClick = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, savedAlert, ex;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    setIsSavingAlert(true);
                    return [
                        4,
                        service_offer_alert/* default.save */.Z.save((0,localize_utils/* getLocale */.K)(locale), normalizeToOfferAlertCreateRequest(currentFilters, (0,localize_utils/* getLocale */.K)(locale)))
                    ];
                case 1:
                    savedAlert = _state.sent();
                    setAlerts((0,_to_consumable_array/* default */.Z)(alerts).concat([
                        savedAlert
                    ]));
                    addSuccessToast((user === null || user === void 0 ? void 0 : (ref = user.configuration) === null || ref === void 0 ? void 0 : ref.availabilityStatus) === "NOT AVAILABLE" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                        ns: "job-offer-list",
                        i18nKey: "messages.success.save-alert-desc-availability",
                        components: {
                            availabilityLink: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.portalV2Contact */.uu.portalV2Contact, router.locale),
                                target: "_blank",
                                rel: "noreferrer"
                            })
                        }
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                        ns: "job-offer-list",
                        i18nKey: "messages.success.save-alert-desc"
                    }), t("messages.success.save-alert"));
                    setIsSavingAlert(false);
                    return [
                        3,
                        3
                    ];
                case 2:
                    ex = _state.sent();
                    if ((0,_instanceof/* default */.Z)(ex, model/* FetchError */.kp) && ex.statusCode >= 500) {
                        console.error("Could not save Manfredite alert. Exception: ".concat(ex), ex);
                    }
                    addErrorToast(t("messages.error.save-alert"));
                    setIsSavingAlert(false);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        addErrorToast,
        addSuccessToast,
        alerts,
        currentFilters,
        locale,
        router.locale,
        t,
        user === null || user === void 0 ? void 0 : (ref = user.configuration) === null || ref === void 0 ? void 0 : ref.availabilityStatus
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (((ref = router.query) === null || ref === void 0 ? void 0 : ref.action) === "create-alert") {
            setIsConfirmSaveModalOpened(true);
            setTimeout(function() {
                (0,utils_router/* removeQueryParamsFromRouter */.q)(router, [
                    "action"
                ]);
            }, 500);
        }
    }, [
        router
    ]);
    return {
        alerts: alerts,
        setAlerts: setAlerts,
        isConfirmSaveModalOpened: isConfirmSaveModalOpened,
        setIsConfirmSaveModalOpened: setIsConfirmSaveModalOpened,
        isSavingAlert: isSavingAlert,
        isManageAlertsModalOpened: isManageAlertsModalOpened,
        setIsManageAlertsModalOpened: setIsManageAlertsModalOpened,
        unsuscribeActionOfferAlert: unsuscribeActionOfferAlert,
        handleOpenManageAlertsClick: handleOpenManageAlertsClick,
        handleCreateAlertClick: handleCreateAlertClick,
        handleSignupClick: handleSignupClick,
        userCanCreateAlerts: userCanCreateAlerts
    };
};

// EXTERNAL MODULE: ./components/shared/Notification.styled.tsx
var Notification_styled = __webpack_require__(67843);
// EXTERNAL MODULE: ./components/shared/Typography.js
var Typography = __webpack_require__(99655);
;// CONCATENATED MODULE: ./features/job-offers/list/components/JobOffersListComponent.styled.ts

function JobOffersListComponent_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 auto;\n  max-width: ",
        ";\n  width: 100%;\n  padding: ",
        " ",
        ";\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: 288px 1fr;\n    gap: ",
        " ",
        ";\n    padding-top: ",
        ";\n  }\n"
    ]);
    JobOffersListComponent_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function JobOffersListComponent_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  && {\n    text-align: center;\n    user-select: none;\n\n    @media (min-width: ",
        ") {\n      text-align: left;\n      grid-column: 2;\n      grid-row: 1;\n\n      &::before {\n        left: 0;\n        transform: unset;\n      }\n    }\n  }\n"
    ]);
    JobOffersListComponent_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function JobOffersListComponent_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-column: 1 / -1;\n  display: flex;\n  justify-content: space-between;\n\n  @media (min-width: ",
        ") {\n    grid-column: 1;\n    display: none;\n  }\n"
    ]);
    JobOffersListComponent_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function JobOffersListComponent_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 14rem;\n"
    ]);
    JobOffersListComponent_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function JobOffersListComponent_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (min-width: ",
        ") {\n    grid-column: 1;\n    grid-row: 1;\n  }\n"
    ]);
    JobOffersListComponent_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function JobOffersListComponent_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  @media (min-width: ",
        ") {\n    grid-column: 2;\n    grid-row: 1 / span 3;\n    padding-top: ",
        ";\n  }\n\n  ",
        " {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    JobOffersListComponent_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var StyledJobOfferListComponent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c2e3ee64-0"
})(JobOffersListComponent_styled_templateObject(), (0,theme/* container */.nC)("xlMax"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl4"));
var StyledJobOfferListTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Heading1 */.nL).withConfig({
    componentId: "sc-c2e3ee64-1"
})(JobOffersListComponent_styled_templateObject1(), (0,theme/* screen */.sp)("lg"));
var StyledFilterSort = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c2e3ee64-2"
})(JobOffersListComponent_styled_templateObject2(), (0,theme/* screen */.sp)("lg"));
var StyledSort = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c2e3ee64-3"
})(JobOffersListComponent_styled_templateObject3());
var JobOffersListComponent_styled_StyledFiltersContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c2e3ee64-4"
})(JobOffersListComponent_styled_templateObject4(), (0,theme/* screen */.sp)("lg"));
var StyledFiltersGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c2e3ee64-5"
})(JobOffersListComponent_styled_templateObject5(), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl5"), Notification_styled/* StyledNotification */.HX, (0,theme/* spacing */.W0)("lg"));

;// CONCATENATED MODULE: ./features/job-offers/list/components/JobOffersListComponent.tsx












var OfferGrid = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1122), __webpack_require__.e(3819), __webpack_require__.e(5502)]).then(__webpack_require__.bind(__webpack_require__, 78045));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78045)
            ];
        }
    },
    ssr: false
});
var OfferListEmpty = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7259).then(__webpack_require__.bind(__webpack_require__, 7259));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7259)
            ];
        }
    },
    ssr: false
});
var OfferAlertConfirmSaveModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7001).then(__webpack_require__.bind(__webpack_require__, 17001));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17001)
            ];
        }
    },
    ssr: false
});
var OfferAlertModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1746).then(__webpack_require__.bind(__webpack_require__, 71746));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(71746)
            ];
        }
    },
    ssr: false
});
var JobOffersListComponent = function(param) {
    var currencies = param.currencies, languages = param.languages, techs = param.techs, techRoles = param.techRoles, allLanguages = param.allLanguages;
    var ref = useJobOffersList({
        languages: languages,
        allLanguages: allLanguages,
        techs: techs
    }), t = ref.t, UIOffers = ref.UIOffers, currentFilters = ref.currentFilters, currentFiltersText = ref.currentFiltersText, loading = ref.loading, activeFilters = ref.activeFilters, setActiveFilters = ref.setActiveFilters, filtersDesktop = ref.filtersDesktop, isDefaultFilter = ref.isDefaultFilter, handleOnFilterChange = ref.handleOnFilterChange, handleOnFilterReset = ref.handleOnFilterReset;
    var ref1 = useJobOffersAlerts({
        currentFilters: currentFilters
    }), alerts = ref1.alerts, setAlerts = ref1.setAlerts, isManageAlertsModalOpened = ref1.isManageAlertsModalOpened, setIsManageAlertsModalOpened = ref1.setIsManageAlertsModalOpened, unsuscribeActionOfferAlert = ref1.unsuscribeActionOfferAlert, handleOpenManageAlertsClick = ref1.handleOpenManageAlertsClick, isConfirmSaveModalOpened = ref1.isConfirmSaveModalOpened, setIsConfirmSaveModalOpened = ref1.setIsConfirmSaveModalOpened, isSavingAlert = ref1.isSavingAlert, handleCreateAlertClick = ref1.handleCreateAlertClick, handleSignupClick = ref1.handleSignupClick, userCanCreateAlerts = ref1.userCanCreateAlerts;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.ZP, {
        hasScrollTop: true,
        filters: !filtersDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(filters_Filters, {
            onFilterChange: handleOnFilterChange,
            onFilterReset: handleOnFilterReset,
            onClose: function() {
                setActiveFilters(false);
            },
            onManageAlertsClick: handleOpenManageAlertsClick,
            onCreateAlertClick: function() {
                return setIsConfirmSaveModalOpened(true);
            },
            isDefaultFilter: isDefaultFilter,
            currentFilter: currentFilters,
            currencies: currencies,
            languages: languages,
            techs: techs,
            techRoles: techRoles,
            allLanguages: allLanguages,
            className: classnames_default()({
                showFilters: activeFilters
            }),
            userHasOfferAlerts: alerts && alerts.length > 0,
            isSavingOfferAlert: isSavingAlert
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledJobOfferListComponent, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledJobOfferListTitle, {
                    editorial: true,
                    children: t("page_title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferAlertModal, {
                    isOpened: isManageAlertsModalOpened,
                    close: function() {
                        return setIsManageAlertsModalOpened(false);
                    },
                    offerAlerts: alerts,
                    techs: techs,
                    techRoles: techRoles,
                    setOfferAlerts: setAlerts,
                    userCanCreateAlerts: userCanCreateAlerts,
                    unsuscribeActionOfferAlert: unsuscribeActionOfferAlert,
                    onCreateAlertClick: function() {
                        setIsManageAlertsModalOpened(false);
                        if (!isDefaultFilter) {
                            setIsConfirmSaveModalOpened(true);
                        }
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferAlertConfirmSaveModal, {
                    isOpen: isConfirmSaveModalOpened,
                    close: function() {
                        return setIsConfirmSaveModalOpened(false);
                    },
                    onConfirm: handleCreateAlertClick,
                    onSignupClick: handleSignupClick
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFilterSort, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                        sizes: "sm",
                        variant: "tertiary",
                        onClick: function() {
                            return setActiveFilters(true);
                        },
                        className: "filters-trigger",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: pro_solid_svg_icons/* faBarsFilter */.fqi
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("filters_title")
                            })
                        ]
                    })
                }),
                filtersDesktop && currentFilters && /*#__PURE__*/ (0,jsx_runtime.jsx)(JobOffersListComponent_styled_StyledFiltersContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(filters_Filters, {
                        onFilterChange: handleOnFilterChange,
                        onFilterReset: handleOnFilterReset,
                        onCreateAlertClick: function() {
                            return setIsConfirmSaveModalOpened(true);
                        },
                        onManageAlertsClick: handleOpenManageAlertsClick,
                        isDefaultFilter: isDefaultFilter,
                        currentFilter: currentFilters,
                        currencies: currencies,
                        languages: languages,
                        techs: techs,
                        techRoles: techRoles,
                        allLanguages: allLanguages,
                        userHasOfferAlerts: alerts && alerts.length > 0,
                        isSavingOfferAlert: isSavingAlert
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFiltersGrid, {
                    children: [
                        !filtersDesktop && currentFiltersText.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Notification/* default */.Z, {
                            variant: "info",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: t("applied_filters", {
                                        count: currentFiltersText.length
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: currentFiltersText.map(function(f, i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    children: f
                                                }),
                                                i < currentFiltersText.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: ", "
                                                })
                                            ]
                                        }, i);
                                    })
                                })
                            ]
                        }),
                        loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: (UIOffers === null || UIOffers === void 0 ? void 0 : UIOffers.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferGrid, {
                                isDefaultFilter: isDefaultFilter,
                                offers: UIOffers,
                                className: classnames_default()({
                                    loading: loading
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferListEmpty, {
                                handleCreateAlertClick: function() {
                                    return setIsConfirmSaveModalOpened(true);
                                },
                                isSavingOfferAlert: isSavingAlert
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_JobOffersListComponent = (JobOffersListComponent);

;// CONCATENATED MODULE: ./features/job-offers/list/JobOffersListPage.tsx








var JobOfferURLNonExistModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2133).then(__webpack_require__.bind(__webpack_require__, 62133));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(62133)
            ];
        }
    },
    ssr: false
});
var JobOffersListPage = function(props) {
    var t = (0,useI18n/* useI18n */.Q)("job-offer-list").t;
    (0,usePageTrack/* usePageTrack */.N)("Website - Page Loaded");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMetadata/* default */.Z, {
                title: t("page_title"),
                desc: t("page_description"),
                url: app_urls/* APP_URLS.jobOffers */.uu.jobOffers,
                imgUrl: "".concat(props.baseUrl).concat((0,paths/* getPublicPath */.A)("/images/cards/card_offers.png")),
                indexable: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_JobOffersListComponent, {
                currencies: props.currencies,
                languages: props.languages,
                techs: props.techs,
                techRoles: props.techRoles,
                allLanguages: props.allLanguages
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(JobOfferURLNonExistModal, {})
        ]
    });
};

;// CONCATENATED MODULE: ./features/job-offers/list/index.ts


;// CONCATENATED MODULE: ./pages/job-offers/index.tsx

var __N_SSG = true;
/* harmony default export */ var job_offers = (JobOffersListPage);


/***/ }),

/***/ 33917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ service_offer_alert; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./utils/fetch.ts
var fetch = __webpack_require__(89608);
// EXTERNAL MODULE: ./utils/headers.ts
var headers = __webpack_require__(93889);
// EXTERNAL MODULE: ./utils/config.ts
var config = __webpack_require__(75339);
;// CONCATENATED MODULE: ./services/service-offer-alert.constants.ts

var ENDPOINT_PATH = "/v2/manfredite/offer-filter";
var NEXT_API_URL = "".concat(config/* config.appUrl */.v.appUrl, "/api").concat(ENDPOINT_PATH);
var API_BASE_URL = "".concat(config/* config.apiUrl */.v.apiUrl).concat(ENDPOINT_PATH);

// EXTERNAL MODULE: ./services/service.language.normalizer.ts
var service_language_normalizer = __webpack_require__(37031);
;// CONCATENATED MODULE: ./services/service-offer-alert.normalizer.ts

var normalizeToManfrediteOfferAlerts = function(res, lang) {
    return res.map(function(item) {
        return normalizeToManfrediteOfferAlert(item, lang);
    });
};
var normalizeToManfrediteOfferAlert = function(res, // eslint-disable-next-line unused-imports/no-unused-vars
lang) {
    var ref, ref1;
    return {
        id: res.id,
        createdAt: new Date(res.createdAt).toISOString(),
        filter: {
            onlyActive: true,
            remoteOptions: res.criteria.remoteOptions || [],
            techs: res.criteria.techs.map(function(tech) {
                return tech.id;
            }) || [],
            techRoles: res.criteria.techRoles.map(function(tech) {
                return tech.id;
            }) || [],
            locations: res.criteria.locations.map(function(location) {
                return {
                    placeId: location.placeId,
                    displayName: location.displayName
                };
            }),
            currency: res.criteria.currency || "€",
            minSalary: ((ref = res.criteria.minSalary) === null || ref === void 0 ? void 0 : ref.toString()) || "",
            offerLanguage: res.criteria.offerLanguage || "",
            text: res.criteria.text || "",
            minLanguages: ((ref1 = res.criteria.minLanguages) === null || ref1 === void 0 ? void 0 : ref1.map(function(minLang) {
                return {
                    id: minLang.id,
                    language: {
                        label: minLang.name,
                        value: minLang.id
                    },
                    level: {
                        label: service_language_normalizer/* CommonDtoLevelToLanguageLevelDict */.x5[minLang.level || "Undefined"] || "not-defined",
                        value: service_language_normalizer/* CommonDtoLevelToLanguageLevelDict */.x5[minLang.level || "Undefined"] || "not-defined"
                    }
                };
            })) || []
        }
    };
};

;// CONCATENATED MODULE: ./services/service-offer-alert.ts






var OfferAlertService = {
    getAll: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(lang, token) {
            var baseUrl, res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        baseUrl = token ? API_BASE_URL : NEXT_API_URL;
                        return [
                            4,
                            fetch/* get */.U2("".concat(baseUrl, "?lang=").concat(lang), (0,headers/* getAuthHeader */.E)(token))
                        ];
                    case 1:
                        res = _state.sent();
                        return [
                            2,
                            normalizeToManfrediteOfferAlerts(res, lang)
                        ];
                }
            });
        });
        return function(lang, token) {
            return _ref.apply(this, arguments);
        };
    }(),
    save: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(lang, offerFilter, token) {
            var baseUrl, res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        baseUrl = token ? API_BASE_URL : NEXT_API_URL;
                        return [
                            4,
                            fetch/* post */.v_("".concat(baseUrl, "?lang=").concat(lang), offerFilter, (0,headers/* getAuthHeader */.E)(token))
                        ];
                    case 1:
                        res = _state.sent();
                        return [
                            2,
                            normalizeToManfrediteOfferAlert(res, lang)
                        ];
                }
            });
        });
        return function(lang, offerFilter, token) {
            return _ref.apply(this, arguments);
        };
    }(),
    remove: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, token) {
            var baseUrl;
            return (0,tslib_es6.__generator)(this, function(_state) {
                baseUrl = token ? API_BASE_URL : NEXT_API_URL;
                return [
                    2,
                    fetch/* _delete */.ZJ("".concat(baseUrl, "/").concat(id), (0,headers/* getAuthHeader */.E)(token))
                ];
            });
        });
        return function(id, token) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var service_offer_alert = (OfferAlertService);


/***/ }),

/***/ 58630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jf": function() { return /* binding */ getOfferUrl; },
/* harmony export */   "Wl": function() { return /* binding */ getCityStringFromUIPlacesAutocompleteItem; },
/* harmony export */   "Z2": function() { return /* binding */ getCanonicalUrl; }
/* harmony export */ });
/* harmony import */ var utils_app_urls__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62177);

/**
 * Get the canonical `offer` URL for a given `origin` and `locale`
 *
 * @param origin - base URL for the canonical link
 * @param offer - (server-side model) to get the title from
 * @param locale - in which `Multilingual` server-side data will be retrieved
 * @returns  The offer canonical URL
 */ function getCanonicalUrl(origin, offer, locale) {
    return "".concat(origin, "/").concat(locale).concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_0__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_0__/* .APP_URLS.jobOffer */ .uu.jobOffer, locale)).concat(getOfferUrl(offer, locale));
}
/**
 * Get the `offer` URL for a given `locale`
 *

 * @param offer - (server-side model) to get the title from
 * @param locale - in which `Multilingual` server-side data will be retrieved
 * @returns  The offer  URL
 */ function getOfferUrl(offer, locale) {
    var slug = offer.slug;
    return "/".concat(offer.id, "/").concat(slug);
}
function cleanLocations(location) {
    return location.replace(", Espa\xf1a", "").replace(", Spain", "");
}
var LOCATIONS_SEPARATOR = ", ";
function getCityStringFromUIPlacesAutocompleteItem(locations, // eslint-disable-next-line @typescript-eslint/no-unused-vars
_locale) {
    return (locations === null || locations === void 0 ? void 0 : locations.map(function(location) {
        return (location === null || location === void 0 ? void 0 : location.displayName) || "";
    }).filter(Boolean).map(cleanLocations).join(LOCATIONS_SEPARATOR)) || "";
}


/***/ }),

/***/ 79546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ removeQueryParamsFromRouter; }
/* harmony export */ });
var removeQueryParamsFromRouter = function(router) {
    var removeList = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    if (removeList.length > 0) {
        removeList.forEach(function(param) {
            return delete router.query[param];
        });
    } else {
        Object.keys(router.query).forEach(function(param) {
            return delete router.query[param];
        });
    }
    router.replace({
        pathname: router.asPath.split("?")[0],
        query: router.query
    }, undefined, {
        shallow: true
    });
};


/***/ }),

/***/ 63201:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 81192:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 25237:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(95805)


/***/ }),

/***/ 60669:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useDebouncedCallback; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked, or until the next browser frame is drawn. The debounced function
 * comes with a `cancel` method to cancel delayed `func` invocations and a
 * `flush` method to immediately invoke them. Provide `options` to indicate
 * whether `func` should be invoked on the leading and/or trailing edge of the
 * `wait` timeout. The `func` is invoked with the last arguments provided to the
 * debounced function. Subsequent calls to the debounced function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * If `wait` is omitted in an environment with `requestAnimationFrame`, `func`
 * invocation will be deferred until the next frame is drawn (typically about
 * 16ms).
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `debounce` and `throttle`.
 *
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0]
 *  The number of milliseconds to delay; if omitted, `requestAnimationFrame` is
 *  used (if available, otherwise it will be setTimeout(...,0)).
 * @param {Object} [options={}] The options object.
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.leading=false]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {number} [options.maxWait]
 *  Specify invoking on the trailing edge of the timeout.
 * @param {boolean} [options.trailing=true]
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * const resizeHandler = useDebouncedCallback(calculateLayout, 150);
 * window.addEventListener('resize', resizeHandler)
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * const clickHandler = useDebouncedCallback(sendMail, 300, {
 *   leading: true,
 *   trailing: false,
 * })
 * <button onClick={clickHandler}>click me</button>
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * const debounced = useDebouncedCallback(batchLog, 250, { 'maxWait': 1000 })
 * const source = new EventSource('/stream')
 * source.addEventListener('message', debounced)
 *
 * // Cancel the trailing debounced invocation.
 * window.addEventListener('popstate', debounced.cancel)
 *
 * // Check for pending invocations.
 * const status = debounced.pending() ? "Pending..." : "Ready"
 */
function useDebouncedCallback(func, wait, options) {
    var _this = this;
    var lastCallTime = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var lastInvokeTime = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
    var timerId = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var lastArgs = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)([]);
    var lastThis = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var result = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var funcRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(func);
    var mounted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(true);
    funcRef.current = func;
    // Bypass `requestAnimationFrame` by explicitly setting `wait=0`.
    var useRAF = !wait && wait !== 0 && typeof window !== 'undefined';
    if (typeof func !== 'function') {
        throw new TypeError('Expected a function');
    }
    wait = +wait || 0;
    options = options || {};
    var leading = !!options.leading;
    var trailing = 'trailing' in options ? !!options.trailing : true; // `true` by default
    var maxing = 'maxWait' in options;
    var maxWait = maxing ? Math.max(+options.maxWait || 0, wait) : null;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        mounted.current = true;
        return function () {
            mounted.current = false;
        };
    }, []);
    // You may have a question, why we have so many code under the useMemo definition.
    //
    // This was made as we want to escape from useCallback hell and
    // not to initialize a number of functions each time useDebouncedCallback is called.
    //
    // It means that we have less garbage for our GC calls which improves performance.
    // Also, it makes this library smaller.
    //
    // And the last reason, that the code without lots of useCallback with deps is easier to read.
    // You have only one place for that.
    var debounced = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
        var invokeFunc = function (time) {
            var args = lastArgs.current;
            var thisArg = lastThis.current;
            lastArgs.current = lastThis.current = null;
            lastInvokeTime.current = time;
            return (result.current = funcRef.current.apply(thisArg, args));
        };
        var startTimer = function (pendingFunc, wait) {
            if (useRAF)
                cancelAnimationFrame(timerId.current);
            timerId.current = useRAF ? requestAnimationFrame(pendingFunc) : setTimeout(pendingFunc, wait);
        };
        var shouldInvoke = function (time) {
            if (!mounted.current)
                return false;
            var timeSinceLastCall = time - lastCallTime.current;
            var timeSinceLastInvoke = time - lastInvokeTime.current;
            // Either this is the first call, activity has stopped and we're at the
            // trailing edge, the system time has gone backwards and we're treating
            // it as the trailing edge, or we've hit the `maxWait` limit.
            return (!lastCallTime.current ||
                timeSinceLastCall >= wait ||
                timeSinceLastCall < 0 ||
                (maxing && timeSinceLastInvoke >= maxWait));
        };
        var trailingEdge = function (time) {
            timerId.current = null;
            // Only invoke if we have `lastArgs` which means `func` has been
            // debounced at least once.
            if (trailing && lastArgs.current) {
                return invokeFunc(time);
            }
            lastArgs.current = lastThis.current = null;
            return result.current;
        };
        var timerExpired = function () {
            var time = Date.now();
            if (shouldInvoke(time)) {
                return trailingEdge(time);
            }
            // https://github.com/xnimorz/use-debounce/issues/97
            if (!mounted.current) {
                return;
            }
            // Remaining wait calculation
            var timeSinceLastCall = time - lastCallTime.current;
            var timeSinceLastInvoke = time - lastInvokeTime.current;
            var timeWaiting = wait - timeSinceLastCall;
            var remainingWait = maxing ? Math.min(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            // Restart the timer
            startTimer(timerExpired, remainingWait);
        };
        var func = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var time = Date.now();
            var isInvoking = shouldInvoke(time);
            lastArgs.current = args;
            lastThis.current = _this;
            lastCallTime.current = time;
            if (isInvoking) {
                if (!timerId.current && mounted.current) {
                    // Reset any `maxWait` timer.
                    lastInvokeTime.current = lastCallTime.current;
                    // Start the timer for the trailing edge.
                    startTimer(timerExpired, wait);
                    // Invoke the leading edge.
                    return leading ? invokeFunc(lastCallTime.current) : result.current;
                }
                if (maxing) {
                    // Handle invocations in a tight loop.
                    startTimer(timerExpired, wait);
                    return invokeFunc(lastCallTime.current);
                }
            }
            if (!timerId.current) {
                startTimer(timerExpired, wait);
            }
            return result.current;
        };
        func.cancel = function () {
            if (timerId.current) {
                useRAF ? cancelAnimationFrame(timerId.current) : clearTimeout(timerId.current);
            }
            lastInvokeTime.current = 0;
            lastArgs.current = lastCallTime.current = lastThis.current = timerId.current = null;
        };
        func.isPending = function () {
            return !!timerId.current;
        };
        func.flush = function () {
            return !timerId.current ? result.current : trailingEdge(Date.now());
        };
        return func;
    }, [leading, maxing, wait, maxWait, trailing, useRAF]);
    return debounced;
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7482,8746,3838,625,4882,2636,9774,2888,179], function() { return __webpack_exec__(63297); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);